import type { IDeliveryNoteRepository, DeliveryNoteListQuery } from '@domain/data-contracts/delivery-note-repository.interface';
import type { DeliveryNote } from '@domain/models/delivery-note.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class DeliveryNotesService {
  public constructor(private readonly repo: IDeliveryNoteRepository) {}

  public list(query: DeliveryNoteListQuery): Promise<PagedResult<DeliveryNote>> {
    return this.repo.list(query);
  }
}
